import { render, staticRenderFns } from "./BranchSelections.vue?vue&type=template&id=19d10ba4"
import script from "./BranchSelections.vue?vue&type=script&lang=js"
export * from "./BranchSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports